import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import 'src/components/SeeAll.scss';


const SeeAll = ({ jobAlerts }) => {
  const seeAllText = 'Zobacz wszystkie';
  const entity = ' · ';
  const jobAlertsURL = useSelector(state => state.configReducer.jobAlertsURL);

  return (
    <a
      data-test="anchor-seeAllJobAlerts"
      href={ jobAlertsURL }
      styleName="all-job-alerts"
      title="Przejdź do konta użytkownika"
    >
      <span>{ seeAllText }</span>
      <span styleName="all-job-alerts__amount">
        { entity }
        { jobAlerts }
      </span>
    </a>
  );
};

SeeAll.propTypes = {
  jobAlerts: PropTypes.number.isRequired
};

export default SeeAll;
